export const iconFontAwesomeGamingDiceThree = (
	<i className="fa-solid fa-dice-three"></i>
);
